import { render, staticRenderFns } from "./CompPeopleTourProgress.vue?vue&type=template&id=4a2ed180"
import script from "./CompPeopleTourProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./CompPeopleTourProgress.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports